const LoadingAnimation = 'LoadingAnimation';
const TopLeaderBoardBanner = 'TopLeaderBoardBanner';
const ProductDetailPageTabBarStyle = 'ProductDetailPageTabBarStyle';
const FlashSaleBarStyle = 'FlashSaleBarStyle';
const PrimaryCallToActionButtonStyle = 'PrimaryCallToActionButtonStyle';
const SecondaryCallToActionButtonStyle = 'SecondaryCallToActionButtonStyle';
const FloatingActionButtonStyle = 'FloatingActionButtonStyle';
const RemainingStockTextStyle = 'RemainingStockTextStyle';

const loadingImage = 'loadingImage';

const topLeaderBoardBanner = 'topLeaderBoardBanner';
const link = 'link';
const linkImage = 'linkImage';
const imageSetting = 'imageSetting';

const productDetailsPageTabBarStyle = 'productDetailsPageTabBarStyle';
const addToCart = 'addToCart';
const buyNow = 'buyNow';
const iconText = 'iconText';
const remindMe = 'remindMe';
const soldOut = 'soldOut';

const flashSaleBarStyle = 'flashSaleBarStyle';
const comingSoonPrice = 'comingSoonPrice';
const comingSoonStatus = 'comingSoonStatus';
const saleNowPrice = 'saleNowPrice';
const saleNowStatus = 'saleNowStatus';
const salesNowCountDownTimer = 'salesNowCountDownTimer';

const primaryCallToActionButtonStyle = 'primaryCallToActionButtonStyle';
const buttonStyle = 'buttonStyle';

const secondaryCallToActionButtonStyle = 'secondaryCallToActionButtonStyle';
const outlineStyle = 'outlineStyle';

const floatingActionButtonStyle = 'floatingActionButtonStyle';
const backToTopButtonBackgroundColor = 'backToTopButtonBackgroundColor';
const backToTopIconColor = 'backToTopIconColor';
const customerServiceBackgroundColor = 'customerServiceBackgroundColor';

const remainingStockTextStyle = 'remainingStockTextStyle';

const backgroundColor = 'backgroundColor';
const defaultBackgroundColor = 'defaultBackgroundColor';
const defaultTextColor = 'defaultTextColor';
const textColor = 'textColor';

export {
  LoadingAnimation,
  TopLeaderBoardBanner,
  ProductDetailPageTabBarStyle,
  FlashSaleBarStyle,
  PrimaryCallToActionButtonStyle,
  SecondaryCallToActionButtonStyle,
  FloatingActionButtonStyle,
  RemainingStockTextStyle,
  loadingImage,
  topLeaderBoardBanner,
  link,
  linkImage,
  imageSetting,
  productDetailsPageTabBarStyle,
  addToCart,
  buyNow,
  iconText,
  remindMe,
  soldOut,
  flashSaleBarStyle,
  comingSoonPrice,
  comingSoonStatus,
  saleNowPrice,
  saleNowStatus,
  salesNowCountDownTimer,
  primaryCallToActionButtonStyle,
  buttonStyle,
  secondaryCallToActionButtonStyle,
  outlineStyle,
  floatingActionButtonStyle,
  backToTopButtonBackgroundColor,
  backToTopIconColor,
  customerServiceBackgroundColor,
  remainingStockTextStyle,
  backgroundColor,
  defaultBackgroundColor,
  defaultTextColor,
  textColor,
};
